var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('section',{attrs:{"id":"wrapper"}},[_c('NavBar',{}),_c('Hero'),_c('Stats'),_c('section',{staticClass:"bigbox lg:mx-auto"},[_c('TagLine'),_c('Partners'),_c('VideoSection'),_c('GreenPhone')],1),_c('LightGreenSection'),_c('Certification'),_c('Footer',{staticClass:"footer"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }